import { render, staticRenderFns } from "./documents-group.vue?vue&type=template&id=b814b302&"
import script from "./documents-group.vue?vue&type=script&lang=js&"
export * from "./documents-group.vue?vue&type=script&lang=js&"
import style0 from "./documents-group.vue?vue&type=style&index=0&id=b814b302&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b814b302')) {
      api.createRecord('b814b302', component.options)
    } else {
      api.reload('b814b302', component.options)
    }
    module.hot.accept("./documents-group.vue?vue&type=template&id=b814b302&", function () {
      api.rerender('b814b302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/documents/documents-group.vue"
export default component.exports